import { ImageType } from '@habity/types';

const apiUrl = process.env.NEXT_PUBLIC_API_URL || '';
const apiKey = process.env.NEXT_PUBLIC_API_KEY || '';

type UploadImageParams = {
  token: string;
  file: File;
  homeId: number;
  agencyId: number;
  sortOrder?: number;
};

type UploadImageResult = {
  success: boolean;
  image: ImageType | null;
  cloudflareId: string | null;
  error: string | null;
};

type DeleteImageResult = {
  success: boolean;
  error: string | null;
};

export async function uploadImageToCloudflare(
  params: UploadImageParams
): Promise<UploadImageResult> {
  const { token, file, homeId, agencyId, sortOrder } = params;

  const formData = new FormData();
  formData.append('file', file);
  formData.append('homeId', String(homeId));
  if (agencyId) formData.append('agencyId', String(agencyId));
  if (sortOrder !== undefined) formData.append('sortOrder', String(sortOrder));

  const url = `${apiUrl}/${agencyId}/providers/cloudflare/images/upload`;
  console.log('[uploadImageToCloudflare] Making request to:', url);

  const response = await fetch(url, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
      'X-API-Key': apiKey,
    },
    body: formData,
  });

  console.log('[uploadImageToCloudflare] Response status:', response.status);

  const result = await response.json();
  console.log('[uploadImageToCloudflare] Response body:', result);

  if (!response.ok || !result.success) {
    return {
      success: false,
      image: null,
      cloudflareId: null,
      error: result.error || 'Upload failed',
    };
  }

  return {
    success: true,
    image: result.image,
    cloudflareId: result.cloudflareId,
    error: null,
  };
}

export async function deleteImageFromCloudflare(
  token: string,
  agencyId: number,
  imageId: number
): Promise<DeleteImageResult> {
  const response = await fetch(`${apiUrl}/${agencyId}/providers/cloudflare/images/${imageId}`, {
    method: 'DELETE',
    headers: {
      Authorization: `Bearer ${token}`,
      'X-API-Key': apiKey,
    },
  });

  const result = await response.json();

  if (!response.ok || !result.success) {
    return { success: false, error: result.error || 'Delete failed' };
  }

  return { success: true, error: null };
}
